/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import { Loader } from '../../atoms/Loader/Loader';
import './DashboardCardStyles.scss';
const BASE_CLASS = 'qmb-ui-dashboard-card';
export function DashboardCard({ title, subtitle, isLoading = false, children, className }) {
    return (React.createElement("div", { className: classNames(BASE_CLASS, className) },
        React.createElement("div", { className: `${BASE_CLASS}__header` },
            React.createElement("h3", { className: `${BASE_CLASS}__title` }, title),
            subtitle && React.createElement("p", { className: `${BASE_CLASS}__subtitle` }, subtitle)),
        React.createElement("div", { className: `${BASE_CLASS}__body` }, isLoading ? (React.createElement("div", { className: `${BASE_CLASS}__loading` },
            React.createElement(Loader, { size: "32" }))) : (children))));
}
